import { Route, Routes } from "react-router-dom";
import { AuthenticationGuard } from "./auth/authentication-guard";
import HomePage from "./pages/HomePage";
import NotFoundPage from "./pages/NotFoundPage";
import ProfilePage from "./pages/ProfilePage";

import "antd/dist/reset.css";
import Main from "./components/layout/Main";
import BrandingPage from "./pages/BrandingPage";
import { CallbackPage } from "./pages/CallbackPage";
import { ChartPage } from "./pages/ChartPage";
import { ContactPage } from "./pages/ContactPage";
import GlobalLoader from "./pages/GlobalLoader";
import SubscriptionPage from "./pages/SubscriptionPage";
import {
  BRANDING,
  CHART,
  CONTACT,
  HOME,
  NEW_CHART,
  PROFILE,
  SUBSCRIPTION,
} from "./routes";
import { useStore } from "./store/store";

function App() {
  const user = useStore((state) => state.user);

  if (!user) {
    return <GlobalLoader />;
  }

  return (
    <Main>
      <Routes>
        <Route
          path={HOME}
          element={<AuthenticationGuard component={HomePage} />}
        />
        <Route
          path={NEW_CHART}
          element={<AuthenticationGuard component={ChartPage} />}
        />
        <Route
          path={CHART}
          element={<AuthenticationGuard component={ChartPage} />}
        />
        <Route
          path={PROFILE}
          element={<AuthenticationGuard component={ProfilePage} />}
        />
        <Route
          path={CONTACT}
          element={<AuthenticationGuard component={ContactPage} />}
        />
        <Route
          path={SUBSCRIPTION}
          element={<AuthenticationGuard component={SubscriptionPage} />}
        />
        <Route
          path={BRANDING}
          element={<AuthenticationGuard component={BrandingPage} />}
        />
        <Route
          path="/callback/:redirectTo?"
          element={<AuthenticationGuard component={CallbackPage} />}
        />
        <Route
          path="/callback/chart/:chartId?"
          element={<AuthenticationGuard component={CallbackPage} />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Main>
  );
}

export default App;
